import React, { Component } from 'react'
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import RaisedButton from 'material-ui/RaisedButton'
import { List, ListItem } from 'material-ui/List'
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton'

import { firebaseDb } from '../../../core/firebase';

import { confirmedGroupActions, getConfirmedGroup } from '../../../core/confirmed-group'
import { groupsActions, getGroupList, getStudentsStagedForInvite } from '../../../core/groups'
import { getAuth } from '../../../core/auth'
import GroupForm from '../../components/group-form'
import GroupList from '../../components/group-list'
import GroupItem from '../../components/group-item'
import StudentStagedForInviteList from '../../components/student-staged-for-invite-list'
import Lottery from '../../components/modals/lottery'
import LotteryGroup from '../../components/modals/lottery-group'
import HousingGroupModal from '../../components/modals/housing-group-modal'

import Subheader from 'material-ui/Subheader';
import CardHalfHeight from '../../components/cards/CardHalfHeight'
import CardFullHeight from '../../components/cards/CardFullHeight'
import CardBasic from '../../components/cards/CardBasic'

import { Grid, Row, Col } from 'react-bootstrap'

import {Tabs, Tab} from 'material-ui/Tabs'


const styles = {
    label: {
        marginBottom: '-10px'
    },
    margBottom: {
        marginBottom: 20
    },
    centerChip: {
        textAlign: 'center',
        paddingbottom: 5,
        marginTop: '-10px'
    },
    buttonOne: {
        marginRight: 15
    },
    helpText: {
        fontSize: 11,
        fontWeight: 'bold'
    },
    pad: {
        paddingBottom: 15,
        paddingTop: 10
    },

    warn: {
        color: '#FF6600'
    }
};

export class HousingGroup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 'a',
            openSendInvitationDialog: false,
            openConfirmSingleDialog: false
        };
        this.handleSendInvitationOpen = this.handleSendInvitationOpen.bind(this)
        this.handleSendInvitationClose = this.handleSendInvitationClose.bind(this)
        this.handleSendInvitationSubmit = this.handleSendInvitationSubmit.bind(this)

        this.handleConfirmSingleOpen = this.handleConfirmSingleOpen.bind(this)
        this.handleConfirmSingleClose = this.handleConfirmSingleClose.bind(this)
        this.handleConfirmSingleSubmit = this.handleConfirmSingleSubmit.bind(this)
    }

  handleChange = (value) => {
      this.setState({
          value: value
      });
  };

  handleSendInvitationOpen = () => {
    this.setState({openSendInvitationDialog: true})
  }

  handleSendInvitationClose = () => {
    this.setState({openSendInvitationDialog: false})
  }

  handleSendInvitationSubmit = () => {
    this.props.currentUserCreateGroup()
    this.handleSendInvitationClose()
  }

  handleConfirmSingleOpen = () => {
    this.setState({openConfirmSingleDialog: true})
  }

  handleConfirmSingleClose = () => {
    this.setState({openConfirmSingleDialog: false})
  }

  handleConfirmSingleSubmit = () => {
    this.props.currentUserCreateSingleGroup()
    this.handleConfirmSingleClose()
  }

  componentWillReceiveProps(nextProps) {
    const currentUser = this.props.currentUser
    const nextCurrentUser = nextProps.currentUser
    if (!currentUser.isInConfirmedGroup && (nextCurrentUser.isInConfirmedGroup && nextCurrentUser.groupId)) {
      this.props.loadConfirmedGroup()
    }
  }
  componentWillMount() {
    this.props.loadGroups()
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.loadConfirmedGroup()
    }
  }

  componentWillUnmount() {
    this.props.unloadGroups()
    const currentUser = this.props.currentUser
    if (currentUser.isInConfirmedGroup && currentUser.groupId) {
      this.props.unloadConfirmedGroup()
    }
  }

  renderStudentList() {
    const { students } = this.props.studentsStagedForInvite
    return <StudentStagedForInviteList students={this.props.studentsStagedForInvite} />
  }

  renderConfirmedGroup() {
    const confirmedGroup = this.props.confirmedGroup



    return (
      <List>
        <Subheader>YOU ARE NOW IN A CONFIRMED GROUP</Subheader>
        <GroupItem group={confirmedGroup} />
      </List>
    )
  }
  render() {
    let indivLottoNum = this.props.currentUser.individualLotteryNumber
    let indivlottoNumDisplayText = `Your Lottery #: ` + indivLottoNum
    let groupLottoNum = 'N/A'
    let grouplottoNumDisplayText = `Your Group Lottery #: ` + groupLottoNum
    if (this.props.confirmedGroup && this.props.confirmedGroup.groupLotteryNumber) {
      groupLottoNum = this.props.confirmedGroup.groupLotteryNumber
      grouplottoNumDisplayText = `Your Group Lottery #:${groupLottoNum}`
    }
    let toolTipText = ''
    if (this.props.studentsStagedForInvite.size > 0) {
      toolTipText = "Click to Send Invites"
    } else {
      toolTipText = "Cannot send empty invite"
    }

    const actionsSendInvitation = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleSendInvitationClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onTouchTap={this.handleSendInvitationSubmit}
      />,
    ]

    const actionsConfirmSingle = [
      <FlatButton
        label="Cancel"
        primary={true}
        onTouchTap={this.handleConfirmSingleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onTouchTap={this.handleConfirmSingleSubmit}
      />,
    ]

    return (
      <div>

          <div className="subheader">
              <h4>Housing Group</h4>
              <HousingGroupModal className="right-float" />
          </div>

          <Grid>


              <Row className="show-grid">
                <p style={styles.centerChip}>
                    <span className="inline">
                        <RaisedButton label={indivlottoNumDisplayText} disabled={true} style={styles.buttonOne}/>
                        <RaisedButton label={grouplottoNumDisplayText} disabled={true} />
                    </span>
                </p>
                <div>
                    <p style={styles.pad}><b>Create Group</b> – Invite friends by searching for their email below and then click their
                    name(s) to add them to your group. When you are ready, click “CONFIRM GROUP INVITATIONS” to
                    send invites to your friends. Remember, <b style={styles.warn}>they need to login and accept their invitation for your
                    group to become active</b> so send them a quick email and text telling them to login and accept.
                    </p>

                    <p style={styles.pad}><b>Create Single</b> – Create a single by clicking the SINGLE button and then the CONFIRM SINGLE button.
                    </p>
                </div>
                  <Col sm={12} md={6}>

                      <CardBasic>
                          <Tabs
                              value={this.state.value}
                              onChange={this.handleChange}
                          >
                              <Tab
                                  label="Housing Group"
                                  value="a"
                              >
                                  <br />
                                  <div className="center full-width full-height">
                                      <p style={styles.label}>Invite Roommates</p>
                                      <GroupForm loadRecordUpdateState={this.props.loadRecordUpdateState}/>



                                      <List>
                                          {this.props.studentsStagedForInvite.size ? this.renderStudentList() : null}
                                      </List>
                                      <div className="bottom">

                                        <RaisedButton label="Send Group Invitations" primary={true} onTouchTap={this.handleSendInvitationOpen} disabled={this.props.studentsStagedForInvite.size === 0}/>
                                        <p style={styles.helpText}>{toolTipText}</p>
                                        <Dialog
                                          title="Are you sure you want to create this group and invite the selected classmates?"
                                          actions={actionsSendInvitation}
                                          modal={true}
                                          open={this.state.openSendInvitationDialog}
                                        >
                                          You can only do this once. You cannot add additional people to your group after sending invitations. The classmates you invite should then log-in to RiteClass and accept the invitation. You will then be permitted to create and submit Housing Preferences. Click Submit to confirm or Cancel to close this dialog.
                                        </Dialog>
                                      </div>
                                  </div>
                              </Tab>
                              <Tab
                                  label="Single"
                                  value="b"
                              >
                                  <br />
                                  <div className="center full-width pad-top">
                                    <RaisedButton label="Confirm Single" primary={true} onTouchTap={this.handleConfirmSingleOpen}/>
                                    <Dialog
                                      title="Are you sure you want to create a single group?"
                                      actions={actionsConfirmSingle}
                                      modal={true}
                                      open={this.state.openConfirmSingleDialog}
                                    >
                                      You can only do this once. You cannot add additional people after creating a single. You will then be permitted to create and submit Housing Preferences. Click Submit to confirm or Cancel to close this dialog.
                                    </Dialog>
                                  </div>
                              </Tab>
                          </Tabs>
                      </CardBasic>
                      <CardHalfHeight>
                        <h4 className="confirmed-header">Confirmed Group</h4>

                        {this.props.confirmedGroup ? this.renderConfirmedGroup() : <p style={styles.helpText}>All members of your group must accept the group invitation in order for the group to be confirmed.</p>}
                      </CardHalfHeight>
                  </Col>
                  <Col sm={12} md={6}>
                      <GroupList
                          groups={this.props.groups}
                          currentUser={this.props.currentUser}
                          onGroupAccept={this.props.currentUserAcceptGroup}
                          onGroupReject={this.props.currentUserRejectGroup}

                      />

                  </Col>
              </Row>
          </Grid>

      </div>
    )
  }
}

const mapStateToProps = createSelector(
  getStudentsStagedForInvite,
  getGroupList,
  getConfirmedGroup,
  getAuth,
  (studentsStagedForInvite, groups, confirmedGroup, currentUser) => ({
    studentsStagedForInvite,
    groups,
    confirmedGroup,
    currentUser
  })
)

const mapDispatchToProps = Object.assign(
  {},
  groupsActions,
  confirmedGroupActions
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HousingGroup);



// WEBPACK FOOTER //
// ./src/views/pages/housing-group/index.js